<template>
  <div>
    <h1>Masz uprawnienia do zastępowania innego użytkownika</h1>
    Administrator udzielił Ci możliwości zalogowania w kontekście innego użytkownika. Jeśli chcesz możesz teraz przełączyć kontekst lub zrobić to później
    wybierając z menu Profil->Zastępstwa.
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field v-model="search" append-icon="search" :label="$t('global.search')" single-line hide-details></v-text-field>
      </v-col>
    </v-row>
    <v-data-table :headers="headers" :items="substitutes" :search="search">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.absent_user_name }}</td>
          <td class="text-left">
            {{ props.item.from_date == null ? "na czas nieokreślony" : props.item.from_date }}
          </td>
          <td class="text-left">
            {{ props.item.to_date == null ? "na czas nieokreślony" : props.item.to_date }}
          </td>
          <td class="text-left">{{ props.item.comment }}</td>
          <td class="justify-center layout px-0">
            <v-btn v-if="props.item.can_login_as" icon class="mx-0" @click="loginAs(props.item)" :disabled="$store.getters['Ajax/loading']">
              <v-icon color="teal">transfer_within_a_station</v-icon>
            </v-btn>
            <v-btn v-if="props.item.can_modify" icon class="mx-0" @click="editItem(props.item)" :disabled="$store.getters['Ajax/loading']">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn v-if="props.item.can_modify" icon class="mx-0" @click="deleteItem(props.item)" :disabled="$store.getters['Ajax/loading']">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "LoginAsView",
  components: {},
  data: () => ({
    search: "",
    headers: [
      { text: "Zastępowany użytkownik", value: "absent_user_name" },
      { text: "Od dnia", value: "from_date" },
      { text: "Do dnia", value: "to_date" },
      { text: "komentarz", value: "comment", sortable: false },
      { text: "", value: "actions", sortable: false }
    ],
    substitutes: []
  }),
  computed: {
    // vehicles: function () {
    //     return this.$store.getters['Vehicle/vehicleList'];
    // }
  },
  methods: {
    loginAs(item) {
      this.$store
        .dispatch("AUTH_LOGIN_AS", item.absent_user_id)
        .then(() => {
          this.$store.dispatch("alertDialog", {
            content: "Pomyślnie zmieniono kontekst użytkownika.",
            title: "OK"
          });
        })
        .catch(() => {
          this.$store.dispatch("alertDialog", {
            content: "Wystąpił błąd - nie można zmienić kontekstu użytkownika.",
            title: "Błąd"
          });
        });
    },

    // eslint-disable-next-line no-unused-vars
    deleteItem(item) {
      alert("TODO"); //TODO usuwanie zastępstw
    },
    // eslint-disable-next-line no-unused-vars
    editItem(item) {
      alert("TODO"); //TODO EDYTOWANIE ZASTĘPSTW
    },
    newItem() {
      window.location = "/settings/auth-admin/add-substitute-user";
    }
  },
  created() {
    this.axios.get("user-substitute/substitutes").then(resp => {
      let resparray = resp.data;
      for (let prop in resparray) {
        this.substitutes.push(resparray[prop]);
      }
    });
  }
};
</script>

<style scoped></style>
